var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtifacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33 3.33C2.6 3.33 2 3.93 2 4.67V6.5C2 7.06 2.35 7.54 2.83 7.74V15.33C2.83 16.44 3.73 17.33 4.83 17.33H15.17C16.27 17.33 17.17 16.44 17.17 15.33V7.74C17.65 7.54 18 7.06 18 6.5V4.67C18 3.93 17.4 3.33 16.67 3.33H3.33ZM15.67 7.83H4.33V15.33C4.33 15.61 4.55 15.83 4.83 15.83H15.17C15.44 15.83 15.67 15.61 15.67 15.33V7.83ZM16.5 6.33V4.83H3.5V6.33H16.5ZM7.5 10.17C7.5 9.75 7.84 9.42 8.25 9.42H11.75C12.16 9.42 12.5 9.75 12.5 10.17C12.5 10.58 12.16 10.92 11.75 10.92H8.25C7.84 10.92 7.5 10.58 7.5 10.17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifacts);
export default __webpack_public_path__ + "static/media/artifacts.0c8dda40f8095aa3911696080735cb67.svg";
export { ForwardRef as ReactComponent };